/*!
 * jQuery IH Tooltip
 *
 * Ripped off from jQuery UI and hacked to insert tooltip as sibling of the target
 * element instead of as child of body.
 *
 * Also, the positioning was buggy so I ripped it out and replaced it with something simpler.
 * Unfortunately we lose collision detection.
 *
 * Removed all jQuery UI dependencies except for the widget building class,
 * which all of our other ih plugins should also use.
 *
 * Depends:
 *  jquery.widget.js
 *
 *
 * Description:
 *
 *  Hovering or focusing on a link or form input will show its tooltip.
 *  We use the title attribute to store the text content for display in the tooltip.
 *
 *
 * Expected Markup:
 *
 *      <input type="text" id="sample_input" title="This is my tooltip text" />
 *
 *      OR
 *
 *      <a href="/some-url.html" title="This is my tooltip text">Text link</a>
 *
 *
 * Create an instance like this:
 *
 * $('#sample_input').tooltip();
 *
 * Or you can target any element in a form that has a title attribute like this:
 *
 * $("form [title]").tooltip();
 *
 *
 **/



/*!
 * jQuery UI Tooltip 1.10.4
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/tooltip/
 *
 * Depends:
 *  jquery.widget.js
 */

(function( $ ) {

var increments = 0;

function addDescribedBy( elem, id ) {
    var describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ );
    describedby.push( id );
    elem
        .data( "ih-tooltip-id", id )
        .attr( "aria-describedby", $.trim( describedby.join( " " ) ) );
}

function removeDescribedBy( elem ) {
    var id = elem.data( "ih-tooltip-id" ),
        describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ ),
        index = $.inArray( id, describedby );
    if ( index !== -1 ) {
        describedby.splice( index, 1 );
    }

    elem.removeData( "ih-tooltip-id" );
    describedby = $.trim( describedby.join( " " ) );
    if ( describedby ) {
        elem.attr( "aria-describedby", describedby );
    } else {
        elem.removeAttr( "aria-describedby" );
    }
}

// takes a target (jqobj) and a position string
// returns an object like { top: 0, left: 0 }
//
// possible values for position string include (in clockwise order):
// top-left, top-center, top-right, right-top, right-center, right-bottom, bottom-right, bottom-center, bottom-left, left-bottom, left-center, left-top
function getPosition(target, position_string) {
    var tpos = target.position(),
        h = target.outerHeight(),
        w = target.outerWidth(),
        pos = { top: tpos.top, left: tpos.left },
        p = position_string.split("-");

    if ( p[0] == "bottom" || p[1] == "bottom" ) pos.top = tpos.top + h;
    if ( p[0] == "right" || p[1] == "right") pos.left = tpos.left + w;
    if ( p[1] == "center" && ( p[0] == "top" || p[0] == "bottom")) pos.left = tpos.left + Math.round(w/2);
    if ( p[1] == "center" && ( p[0] == "left" || p[0] == "right")) pos.top = tpos.top + Math.round(h/2);

//    console.log("tpos", tpos);
//    console.log("pos", pos);

    return pos;
}


$.widget( "ih.tooltip", {
    options: {
        content: function() {
            // support: IE<9, Opera in jQuery <1.7
            // .text() can't accept undefined, so coerce to a string
            var title = $( this ).attr( "title" ) || "";
            // Escape title, since we're going from an attribute to raw HTML
            return $( "<a>" ).text( title ).html();
        },
//        position: 'right-top', // top-left, top-center, top-right, right-top, right-center, right-bottom, bottom-right, bottom-center, bottom-left, left-bottom, left-center, left-top
        // tooltips are always positioned to the right top of the target
        position: 'right-top',

        cssPrefix: 'ih_',
        track: false,

        // callbacks
        close: null,
        open: null
    },

    _create: function() {
        this._on({
            mouseover: "open",
            focusin: "open"
        });

        // IDs of generated tooltips, needed for destroy
        this.tooltips = {};
        // IDs of parent tooltips where we removed the title attribute
        this.parents = {};

        if ( this.options.disabled ) {
            this._disable();
        }
    },

    open: function( event ) {

        var that = this;
        var target = this.element;

        // No element to show a tooltip for or the tooltip is already open
        if ( !target.length || target.data( "ih-tooltip-id" ) ) {
            return;
        }

        if ( target.attr( "title" ) ) {
            target.data( "ih-tooltip-title", target.attr( "title" ) );
        }

        target.data( "ih-tooltip-open", true );

        // kill parent tooltips, custom or native, for hover
        if ( event && event.type === "mouseover" ) {
            target.parents().each(function() {
                var parent = $( this ),
                    blurEvent;
                if ( parent.data( "ih-tooltip-open" ) ) {
                    blurEvent = $.Event( "blur" );
                    blurEvent.target = blurEvent.currentTarget = this;
                    that.close( blurEvent, true );
                }
                if ( parent.attr( "title" ) ) {
                    parent.uniqueId();
                    that.parents[ this.id ] = {
                        element: this,
                        title: parent.attr( "title" )
                    };
                    parent.attr( "title", "" );
                }
            });
        }

        this._updateContent( target, event );
    },

    _updateContent: function( target, event ) {
        var content,
            contentOption = this.options.content,
            that = this,
            eventType = event ? event.type : null;

        if ( typeof contentOption === "string" ) {
            return this._open( event, target, contentOption );
        }

        content = contentOption.call( target[0], function( response ) {
            // ignore async response if tooltip was closed already
            if ( !target.data( "ih-tooltip-open" ) ) {
                return;
            }
            // IE may instantly serve a cached response for ajax requests
            // delay this call to _open so the other call to _open runs first
            that._delay(function() {
                // jQuery creates a special event for focusin when it doesn't
                // exist natively. To improve performance, the native event
                // object is reused and the type is changed. Therefore, we can't
                // rely on the type being correct after the event finished
                // bubbling, so we set it back to the previous value. (#8740)
                if ( event ) {
                    event.type = eventType;
                }
                this._open( event, target, response );
            });
        });
        if ( content ) {
            this._open( event, target, content );
        }
    },

    _open: function( event, target, content ) {
        var tooltip, events, delayedShow,
            positionOption = $.extend( {}, this.options.position );

        if ( !content ) {
            return;
        }

        // Content can be updated multiple times. If the tooltip already
        // exists, then just update the content and bail.
        tooltip = this._find( target );
        if ( tooltip.length ) {
            tooltip.find( "." + this.options.cssPrefix + "tooltip_content" ).html( content );
            return;
        }

        // if we have a title, clear it to prevent the native tooltip
        // we have to check first to avoid defining a title if none exists
        // (we don't want to cause an element to start matching [title])
        //
        // We use removeAttr only for key events, to allow IE to export the correct
        // accessible attributes. For mouse events, set to empty string to avoid
        // native tooltip showing up (happens only when removing inside mouseover).
        if ( target.is( "[title]" ) ) {
            if ( event && event.type === "mouseover" ) {
                target.attr( "title", "" );
            } else {
                target.removeAttr( "title" );
            }
        }

        tooltip = this._tooltip( target );
        addDescribedBy( target, tooltip.attr( "id" ) );
        tooltip.find( "." + this.options.cssPrefix + "tooltip_content" ).html( content );

        var pos = getPosition( target, this.options.position );
        tooltip.css({
            'position': 'absolute',
            'top': pos.top,
            'left': pos.left
        });

        // the jquery UI positioning is buggy, so replacing it with something simpler above. - SG
        // we lose collision detection and some other nice features.

//        function position( event ) {
//            positionOption.of = event;
//            if ( tooltip.is( ":hidden" ) ) {
//
//                console.log("Tooltip is hidden!");
//
//                return;
//            }
//
//            console.log("mousemove positioning the tooltip!");
//
//            tooltip.position( positionOption );
//        }
//        if ( this.options.track && event && /^mouse/.test( event.type ) ) {
//            this._on( this.document, {
//                mousemove: position
//            });
//            // trigger once to override element-relative positioning
//            position( event );
//        } else {
//
//            console.log("positioning the tooltip!");
//            console.log("target", target);
//
//            tooltip.position( $.extend({
//                of: target
//            }, this.options.position ) );
//        }

        tooltip.hide();

        this._show( tooltip, this.options.show );

        // trigger the open callback
        this._trigger( "open", event, { tooltip: tooltip } );

        events = {
            keyup: function( event ) {
                if ( event.keyCode === 27 ) { // escape
                    var fakeEvent = $.Event(event);
                    fakeEvent.currentTarget = target[0];
                    this.close( fakeEvent, true );
                }
            },
            remove: function() {
                this._removeTooltip( tooltip );
            }
        };
        if ( !event || event.type === "mouseover" ) {
            events.mouseleave = "close";
        }
        if ( !event || event.type === "focusin" ) {
            events.focusout = "close";
        }
        this._on( true, target, events );
    },

    close: function( event ) {
//        return;

        var that = this,
            target = $( event ? event.currentTarget : this.element ),
            tooltip = this._find( target );

        // disabling closes the tooltip, so we need to track when we're closing
        // to avoid an infinite loop in case the tooltip becomes disabled on close
        if ( this.closing ) {
            return;
        }

        // only set title if we had one before (see comment in _open())
        if ( target.data( "ih-tooltip-title" ) ) {
            target.attr( "title", target.data( "ih-tooltip-title" ) );
        }

        removeDescribedBy( target );

        tooltip.stop( true );
        this._hide( tooltip, this.options.hide, function() {
            that._removeTooltip( $( this ) );
        });

        target.removeData( "ih-tooltip-open" );
        this._off( target, "mouseleave focusout keyup" );
        // Remove 'remove' binding only on delegated targets
        if ( target[0] !== this.element[0] ) {
            this._off( target, "remove" );
        }
        this._off( this.document, "mousemove" );

        if ( event && event.type === "mouseleave" ) {
            $.each( this.parents, function( id, parent ) {
                $( parent.element ).attr( "title", parent.title );
                delete that.parents[ id ];
            });
        }

        this.closing = true;
        this._trigger( "close", event, { tooltip: tooltip } );
        this.closing = false;
    },

    _tooltip: function( element ) {
        var that = this,
            id = "ih_tooltip_" + increments++,
            tooltip_anchor = $( "<div>" )
                .attr({
                    id: id,
                    role: "tooltip"
                })
                .addClass( this.options.cssPrefix + "tooltip_anchor " + this.options.position.replace("-","_") );

        var tooltip = $( "<div>" )
            .addClass( that.options.cssPrefix + 'tooltip ')
            .appendTo( tooltip_anchor );

        $( "<div>" )
            .addClass( that.options.cssPrefix + 'tooltip_content')
            .appendTo( tooltip );


        tooltip_anchor.appendTo( this.element.parent() );
        this.tooltips[ id ] = element;
        return tooltip_anchor;
    },

    _find: function( target ) {
        var id = target.data( "ih-tooltip-id" );
        return id ? $( "#" + id ) : $();
    },

    _removeTooltip: function( tooltip ) {
        tooltip.remove();
        delete this.tooltips[ tooltip.attr( "id" ) ];
    },

    _destroy: function() {
        var that = this;

        // close open tooltips
        $.each( this.tooltips, function( id, element ) {
            // Delegate to close method to handle common cleanup
            var event = $.Event( "blur" );
            event.target = event.currentTarget = element[0];
            that.close( event, true );

            // Remove immediately; destroying an open tooltip doesn't use the
            // hide animation
            $( "#" + id ).remove();

            // Restore the title
            if ( element.data( "ih-tooltip-title" ) ) {
                element.attr( "title", element.data( "ih-tooltip-title" ) );
                element.removeData( "ih-tooltip-title" );
            }
        });
    }
});

}( jQuery ) );
